<template>
    <div>
        <section class="hero is-primary is-bold is-medium">
            <div class="hero-body">
                <div class="container has-text-centered">
                    <div class="columns is-centered">
                        <div class="column is-narrow">
                            <!--svg :style="svgStyle">
              <text
                :style="textStyle"
                class="title has-text-weight-bold is-1"
                x="50%"
                y="50%"
                text-anchor="middle"
                dominant-baseline="central"
              >
                {{ initial }}
              </text>
            </svg-->
                            <div
                                class="lb-circle is-large has-background-pale-grey"
                            >
                                <p
                                    class="title has-text-weight-bold is-1 has-text-primary"
                                >
                                    {{ initial }}
                                </p>
                            </div>
                        </div>
                        <div
                            class="column is-narrow has-text-left has-text-centered-mobile"
                        >
                            <p class="title has-text-weight-bold is-size-5">
                                {{ $store.getters.school.name }}
                            </p>
                            <p>
                                <strong
                                    v-t="'School.address'"
                                    class="has-text-white"
                                >
                                </strong>
                                {{ $store.getters.school.street }},
                                {{ $store.getters.school.city }}
                            </p>
                            <p>
                                <strong
                                    v-t="'School.city'"
                                    class="has-text-white"
                                >
                                </strong>
                                {{ $store.getters.school.state }}
                            </p>
                            <p>
                                <strong
                                    v-t="'School.email'"
                                    class="has-text-white"
                                >
                                </strong>
                                {{ $store.getters.school.email }}
                            </p>
                        </div>
                    </div>
                    <div class="columns is-centered pt-6">
                        <div class="column is-narrow px-6">
                            <div>
                                <div
                                    class="lb-circle is-small has-background-pale-grey"
                                >
                                    <p
                                        class="has-text-primary has-text-weight-bold"
                                    >
                                        {{ stats.members }}
                                    </p>
                                </div>
                                <p
                                    v-t="'Dashboard.users_count'"
                                    class="has-text-weight-bold"
                                ></p>
                            </div>
                        </div>
                        <div class="column is-narrow px-6">
                            <div>
                                <div
                                    class="lb-circle is-small has-background-pale-grey"
                                >
                                    <p
                                        class="has-text-primary has-text-weight-bold"
                                    >
                                        {{ stats.projects }}
                                    </p>
                                </div>
                                <p
                                    v-t="'Dashboard.projects_count'"
                                    class="has-text-weight-bold"
                                ></p>
                            </div>
                        </div>
                        <div class="column is-narrow px-6">
                            <div>
                                <div
                                    class="lb-circle is-small has-background-pale-grey"
                                >
                                    <p
                                        class="has-text-primary has-text-weight-bold"
                                    >
                                        {{ stats.highlighted || 0 }}
                                    </p>
                                </div>
                                <p
                                    v-t="'Dashboard.highlighted_projects_count'"
                                    class="has-text-weight-bold"
                                ></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section
            class="section has-background-very-light-pink lb-school-codes-section"
        >
            <div class="columns is-centered">
                <div class="column is-6">
                    <p
                        v-t="'School.teachers_code_title'"
                        for=""
                        class="has-text-weight-bold pb-1"
                    ></p>
                    <div class="lb-school-code-container">
                        <div
                            class="notification is-white mb-0 lb-school-code-notification"
                        >
                            <p class="title is-size-3 has-text-weight-bold">
                                <span class="icon is-left has-text-black">
                                    <i class="mdi mdi-24px mdi-key-variant"></i>
                                </span>
                                {{ stats.teacherCode }}
                            </p>
                        </div>
                        <figure class="image is-64x64 lb-code ml-3">
                            <vue-qrcode
                                :value="stats.teacherCode"
                                :margin="0"
                            />
                        </figure>
                    </div>
                    <p
                        v-t="'School.students_code_title'"
                        for=""
                        class="has-text-weight-bold pb-1"
                    ></p>
                    <div class="lb-school-code-container">
                        <div
                            class="notification is-white mb-0 lb-school-code-notification"
                        >
                            <p class="title is-size-3 has-text-weight-bold">
                                <span class="icon is-left has-text-black">
                                    <i class="mdi mdi-24px mdi-key-variant"></i>
                                </span>
                                {{ stats.studentCode }}
                            </p>
                        </div>
                        <figure class="image is-64x64 lb-code ml-3">
                            <vue-qrcode
                                :value="stats.studentCode"
                                :margin="0"
                            />
                        </figure>
                    </div>
                </div>
            </div>
            <p v-t="'School.codes_hint'" class="has-text-centered"></p>
        </section>
    </div>
</template>

<script>
import { getSchoolStatistics } from '@/services/API';
import VueQrcode from 'vue-qrcode';
export default {
    components: {
        VueQrcode,
    },
    data() {
        return { stats: {} };
    },
    computed: {
        initial() {
            const name = this.$store.getters.school.name || '';
            return name.charAt(0).toUpperCase();

            const splittedName = name.split(' ');

            if (splittedName.length > 1) {
                return splittedName[0].charAt(0) + splittedName[1].charAt(0);
            } else {
                return name.substring(0, 2);
            }
        },
        svgStyle() {
            // use hsl to define the background color.
            const letterIndex = this.initial.charCodeAt() - 64;
            const hue = (360 / 26) * letterIndex;
            const backgroundColor = `hsl(${hue}, 68%, 48%)`;
            return {
                width: `130px`,
                height: `130px`,
                borderRadius: '100%',
                backgroundColor,
            };
        },
        textStyle() {
            return {
                fill: 'rgba(255, 255, 255, .7)',
                fontSize: `${this.size * 0.65}px`,
            };
        },
    },
    mounted() {
        getSchoolStatistics().then((result) => {
            this.stats = result.data;
        });
    },
};
</script>

<style scoped>
.hero-body {
    padding-bottom: 7rem !important;
    padding-top: 7rem !important;
}

.lb-school-code-container {
    align-items: flex-start;
    display: flex;
}
.lb-school-code-container > .lb-code {
    flex-basis: auto;
    flex-grow: 0;
    flex-shrink: 0;
}
.lb-school-code-container > .lb-school-code-notification {
    flex-basis: auto;
    flex-grow: 1;
    flex-shrink: 1;
}
</style>
